import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import Account from "./profile/Account";
import ChangePw from "./profile/ChangePw";

export default function Profile() {
  return (
    <div>
      <div className="container mt-4">
        <div className="row">
          <div className="col-12">
            <div className="pageTitle">
              <h1>Profile</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <Tabs
          defaultActiveKey="account"
          id="fill-tab-example"
          className="addBusiness-tab mb-3"
          fill
        >
          <Tab eventKey="account" title="Account">
            <Account />
          </Tab>
          <Tab eventKey="change-pw" title="Change Password">
            <ChangePw />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
